module.exports = __webpack_public_path__ + "static/lembaga-pendidikan@2x-3acbff21a9417b297f531689158385a2.png";